module.exports = __webpack_public_path__ + "static/media/legenda-bi.a3664bd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/legenda-bi.png
// module id = 891
// module chunks = 0